module.exports = __webpack_public_path__ + "static/media/hot.b0209485.svg";